var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "brochure-selection" }, [
    _c("p", { staticClass: "brochure-selection__introduction" }, [
      _vm._v(
        "You have " + _vm._s(_vm.brochureCount) + " selected brochure(s):"
      ),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "brochure-selection__list" },
      _vm._l(_vm.brochureSelection, function (brochure) {
        return _c(
          "li",
          { key: brochure.code, staticClass: "brochure-selection__list-item" },
          [
            _c("BrochureSelectionItem", {
              attrs: { brochure: brochure, brandName: _vm.brandName },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "brochure-selection__list-link link",
        attrs: {
          "aria-label": "Change your selection",
          title: "Click to change your selection",
        },
        on: { click: _vm.changeState },
      },
      [_vm._v("Change selection")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }